import React, { FunctionComponent } from 'react';

import { Experiment } from '../ABTesting/Experiment';
import { Variation } from '../ABTesting/Variation';
import { DonateButton } from '../DonateButton/DonateButton';
import FacebookShare from '../SocialButtons/FacebookShare';
import { Share } from '../SocialButtons/Share';
import { MarkSuccessOnClick } from '../MarkSuccessOnClick/MarkSuccessOnClick';

const FundraisingCTA: FunctionComponent = () => (
  <>
    <DonateButton
      key="donateButton"
      className="jg-space-mrsm jg-space-mrn@lg jg-space-mbsm@lg"
      trackingDataPageSection="FundraisingCTA"
    />
    <Experiment slug="b2c_social_share_button">
      <Variation name="A">
        <MarkSuccessOnClick
          testSlug="b2c_social_share_button"
          successType="facebook-share"
        >
          <FacebookShare key="facebookShare" />
        </MarkSuccessOnClick>
      </Variation>
      <Variation name="B">
        <Share />
      </Variation>
    </Experiment>
  </>
);

export default FundraisingCTA;
